import { Link } from 'react-router-dom';
import MarketingNav from './MarketingNav';
import MarketingFooter from './MarketingFooter';

const tiers = [
  {
    name: 'Scribe Starter',
    price: 'Contact us',
    description: 'For small clinics and solo practitioners getting started with AI documentation.',
    features: [
      'AI Medical Scribe for 1–3 doctors',
      'SOAP notes & referral letters',
      'Up to 200 consultations/month',
      'Email support',
    ],
    highlight: false,
    cta: 'Request Access',
  },
  {
    name: 'Scribe Pro',
    price: 'Contact us',
    description: 'For growing clinics that need more capacity and richer clinical documentation.',
    features: [
      'AI Medical Scribe for up to 10 doctors',
      'SOAP notes, referrals & discharge summaries',
      'Unlimited consultations',
      'Priority support',
      'Custom templates',
    ],
    highlight: true,
    cta: 'Request Access',
  },
  {
    name: 'Ops Bundle',
    price: 'Contact us',
    description: 'Full platform access — Scribe Pro plus the complete Operations AI module.',
    features: [
      'Everything in Scribe Pro',
      'Healthcare Operations AI',
      'Scheduling, bed & pharmacy management',
      'Multi-facility dashboard',
      'Dedicated onboarding',
    ],
    highlight: false,
    cta: 'Request Access',
  },
];

export default function MarketingPricing() {
  return (
    <div className="bg-[#F0F9FF] min-h-screen flex flex-col">
      <MarketingNav />

      <section className="bg-[#0A2540] text-white py-16 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">Simple, transparent pricing</h1>
          <p className="text-slate-300 text-lg">
            We're in Early Access. Reach out and we'll find a plan that fits your facility.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className={`rounded-2xl p-8 border flex flex-col ${
                tier.highlight
                  ? 'bg-[#0A2540] text-white border-[#0E7490] shadow-lg'
                  : 'bg-white text-[#0F172A] border-slate-100 shadow-sm'
              }`}
            >
              {tier.highlight && (
                <div className="text-xs font-semibold text-[#06B6D4] uppercase tracking-wider mb-3">Most Popular</div>
              )}
              <h3 className={`text-xl font-bold mb-1 ${tier.highlight ? 'text-white' : 'text-[#0A2540]'}`}>
                {tier.name}
              </h3>
              <p className={`text-sm mb-4 ${tier.highlight ? 'text-slate-300' : 'text-[#64748B]'}`}>
                {tier.description}
              </p>
              <ul className="space-y-2 mb-8 flex-1">
                {tier.features.map((f) => (
                  <li key={f} className={`flex items-start gap-2 text-sm ${tier.highlight ? 'text-slate-200' : 'text-[#0F172A]'}`}>
                    <span className="text-[#06B6D4] mt-0.5 flex-shrink-0">✓</span>
                    {f}
                  </li>
                ))}
              </ul>
              <Link
                to="/contact"
                className={`text-center font-semibold px-6 py-3 rounded-lg transition-colors ${
                  tier.highlight
                    ? 'bg-[#06B6D4] text-white hover:bg-[#0E7490]'
                    : 'bg-[#0A2540] text-white hover:bg-[#0E7490]'
                }`}
              >
                {tier.cta}
              </Link>
            </div>
          ))}
        </div>

        {/* Enterprise */}
        <div className="max-w-3xl mx-auto mt-12 bg-white rounded-2xl p-8 border border-slate-100 shadow-sm text-center">
          <h3 className="text-xl font-bold text-[#0A2540] mb-2">Enterprise</h3>
          <p className="text-[#64748B] text-sm mb-4">
            For hospital groups, health networks, and government facilities. Custom pricing, dedicated infrastructure, SLA guarantee, and training.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-[#0E7490] text-white font-semibold px-8 py-3 rounded-lg hover:bg-[#0A2540] transition-colors"
          >
            Talk to us
          </Link>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
